<template>
  <v-data-table
    :loading="loading"
    :headers="headers"
    :items="items"
    :search="search"
  >
    <template v-slot:item.actions="{ item }">
      <div class="my-3">
        <v-btn
          small
          color="error"
          :id="`domain-table-delete-btn-${item.id}`"
          @click="() => $emit('delete', item)"
          v-if-has-permission:hide="deleteDomainPermission"
        >
          Delete Domain
        </v-btn>
      </div>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'DomainsTable',
  props: {
    search: String,
  },
  data: () => ({
    items: [],
    headers: [
      { text: 'Domain Name', value: 'name' },
      {
        text: 'Actions',
        value: 'actions',
        width: 300,
      },
    ],
    loading: false,
  }),
  computed: {
    deleteDomainPermission: vm => vm.$permissions.DELETE_DOMAIN,
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$requests
        .get('/v1/domains')
        .then(response => {
          this.items = response.data;
        })
        .catch(() => {
          this.$toast.error('Could not resolve domains...', { timeout: 3000 });
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
